import React, { useState, useContext, useEffect } from "react";
import styles from "./Login.module.css";
import auth from "../../Auth/Auth.js";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { assests } from "../../assets/assests.js";
import { LoginPageContext } from "../../store/LoginPageContext.jsx";
import { ToastContainer, toast } from "react-toastify";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { LanguageContext } from "../LanguageContext/LanguageContext.jsx";
import "react-toastify/dist/ReactToastify.css";
import { useLastUrl } from "../../store/LastUrlContext.jsx";
import PopUp from "./PopUp.jsx";
import { usePopupContext } from "./PopupContext.jsx";
import GoogleLogo from "../../assets/GoogleLogin.png";
const lmsUrl = import.meta.env.VITE_LMS_URL;
// Moodle Web Service Configuration

const LoginSuccess = () => {
  const lastUrl = useLastUrl();
  const { popupData, setPopupValues } = usePopupContext();
  const [isErrorComponentVisible, setIsErrorComponentVisible] = useState(false);

  // Using useEffect to set state values after the component is mounted
  useEffect(() => {
    setPopupValues("userExists");
    setIsErrorComponentVisible(true);
  }, [setPopupValues]);

  return (
    <>
      {isErrorComponentVisible && (
        <div style={{ position: 'absolute', top: "0px" }}>
          <PopUp
            titleEN={popupData.titleEN}
            titleAR={popupData.titleAR}
            descriptionEN={popupData.descriptionEN}
            descriptionAR={popupData.descriptionAR}
            buttonText1EN={popupData.buttonText1EN}
            buttonText1AR={popupData.buttonText1AR}
            buttonText2EN={popupData.buttonText2EN}
            buttonText2AR={popupData.buttonText2AR}
            linkText1EN={popupData.linkText1EN}
            linkText1AR={popupData.linkText1AR}
            linkText2EN={popupData.linkText2EN}
            linkText2AR={popupData.linkText2AR}
            button1Link={popupData.button1Link}
            button2Link={popupData.button2Link}
          />
        </div>
      )}
      <div className={styles.container}>
        {/* Add any additional content here */}
      </div>
    </>
  );
};

export default LoginSuccess;
